import { LocalStorageService } from "./local-storage.service";
import { SessionService } from "./session.service";
import { jwtDecode } from "jwt-decode";

const { REACT_APP_API_BASE_URL } = process.env;

const AuthService = {
  getAccessToken() {
    return LocalStorageService.getItem("token") || null;
  },

  setAccessToken(aToken) {
    LocalStorageService.setItem("token", aToken);
  },

  getRefreshToken() {
    return LocalStorageService.getItem("refreshToken") || null;
  },

  getTokenExpire() {
    return LocalStorageService.getItem("tokenExpiresAt");
  },

  // Stores the token pair from login, confirmCode or refreshToken. The refresh
  // token is single-use, so both values are always replaced together.
  setSession(user) {
    LocalStorageService.setItem("token", user.token);
    LocalStorageService.setItem("refreshToken", user.refreshToken || "");
    LocalStorageService.setItem("tokenExpiresAt", user.tokenExpiresAt || "");
    LocalStorageService.setItem(
      "refreshTokenExpiresAt",
      user.refreshTokenExpiresAt || ""
    );
  },

  isAuthenticated() {
    const token = this.getAccessToken();
    if (token) {
      let decodedToken = token && jwtDecode(token);
      let currentDate = new Date();
      return !(decodedToken?.exp * 1000 < currentDate.getTime() || token);
    }
    return false;
  },

  getUser() {
    if (this.isAuthenticated()) {
      return LocalStorageService.getItem("user");
    } else {
      return null;
    }
  },

  setUser(user) {
    LocalStorageService.setItem("user", user);
  },

  clearSession() {
    LocalStorageService.removeItem("atoken");
    LocalStorageService.removeItem("user");
    LocalStorageService.clear();
    SessionService.clear();
    localStorage.clear();
  },

  // The server already rejected the session (failed refresh), so there is
  // nothing to revoke — just drop local state and go to login.
  endSession() {
    this.clearSession();
    window.location.href = "/login";
  },

  logout() {
    revokeRefreshToken(this.getRefreshToken());
    this.endSession();
  },
};

// Fire-and-forget. `keepalive` lets the request finish even though the page
// navigates to /login right after. The endpoint is anonymous and always
// succeeds, so there is nothing to wait for.
const revokeRefreshToken = (refreshToken) => {
  if (!refreshToken || !REACT_APP_API_BASE_URL) return;
  try {
    fetch(`${REACT_APP_API_BASE_URL.replace(/\/+$/, "")}/api/Account/logout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // Revoking is best effort; local logout still happens.
  }
};

export default AuthService;
